import * as React from "react";
import styled, { css } from "styled-components";
import {
  ConstBreakPoint,
  ConstColor,
  ConstFontStyle,
  ConstFontWeight,
  ConstMargin,
} from "../../../../config/styles_const/styles_const";

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  icon?: string;
  defaultMargin?: boolean;
}

const HeadlineMiddleDefault: React.SFC<IProps> = (props) => {
  const { icon, defaultMargin, children, ...HeadlineProps } = props;

  return <h2 {...HeadlineProps}>{children}</h2>;
};

const HeadlineMiddle = styled(HeadlineMiddleDefault)`
  color: ${ConstColor.Base};
  font-style: normal;
  font-weight: ${ConstFontStyle.SpHeadlineMiddle.fontWeight};
  font-size: ${ConstFontStyle.SpHeadlineMiddle.fontSize};
  line-height: ${ConstFontStyle.SpHeadlineMiddle.lineHeight};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    font-weight: ${ConstFontStyle.HeadlineMiddle.fontWeight};
    font-size: ${ConstFontStyle.HeadlineMiddle.fontSize};
    line-height: ${ConstFontStyle.HeadlineMiddle.lineHeight};
  }

  & > em {
    font-style: inherit;
    font-weight: ${ConstFontWeight.BOLD};
    background: ${ConstColor.TableTh};
    padding: 0 5px;
  }

  ${(props) =>
    props.defaultMargin &&
    css`
      margin-bottom: ${ConstMargin.SpHeadlineMiddleBottom};
      @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: ${ConstMargin.HeadlineMiddleBottom};
      }
    `}

  ${(props) =>
    props.icon &&
    css`
      ::before {
        margin-right: ${ConstMargin.HeadlineIconRight};
        content: ${props.icon};
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
    `}
`;

export default HeadlineMiddle;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/text/headline_middle.tsx